import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import AppComponent from "../components/App/App";
import * as restaurantActions from '../actions/restaurantActions';
import * as userActions from '../actions/userActions';
import * as productActions from '../actions/productActions';
import * as pickUpActions from '../actions/pickUpTimeActions';
import * as appActions from '../actions/appActions';
import axios from "axios";
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import {DEFAULT_LANGUAGE, LANGUAGES} from "../constants";
import * as _ from 'lodash';
import {getRestaurantByName} from '../helpers';


class AppLayout extends Component {
  constructor(props) {
    super(props);

    if (process.env.NODE_ENV === 'development') {
      axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
    }

    axios.interceptors.request.use(config => {
      const token = localStorage.getItem('userToken');
      let language = localStorage.getItem('i18nextLng');
      if (token) {
        console
        config.headers.Authorization = `Token ${token}`;
      }
      if (language) {
        if (!_.includes(Object.keys(LANGUAGES), language)) {
          language = DEFAULT_LANGUAGE;
        }
        config.headers['X-SELECT-LANGUAGE'] = language;
      }
      return config;
    }, error => {
      return Promise.reject(error);
    });

    axios.interceptors.response.use(response => {
        return response;
      }, error => {
        const errorResponse = error.response;
        if (errorResponse) {
          if (errorResponse.status === 401) {
            props.exitCustomer();
            if (props.location.pathname.indexOf('profile') !== -1) {
              props.selectType('pizza');
              props.history.push(props.location.pathname);
            }
          }
          if (errorResponse.status === 404) {
            props.history.push('/not-found');
          }
          if (errorResponse.status === 500) {
            props.history.push('/internal-error');
          }
        } else {
          props.history.push('/internal-error');
        }
        return Promise.reject(error);
      }
    );

    const {signInAction} = this.props;
    if (localStorage.getItem('userToken')) {
      signInAction();
    }
  };

  excludePath(location) {
    const exclude = ['reset', 'policy'];
    const path = location.split('/')[1];
    return _.includes(exclude, path);
  }

  componentDidMount() {
    const {currentRestaurantId, fetchRestaurants, selectedRestaurant, location, history,
      getServerTime, setServerTime} = this.props;
    fetchRestaurants().then(() => {
      const pathnameList = location.pathname.split('/');
      let restaurantID = currentRestaurantId;
      let restaurantFromUrl = getRestaurantByName(pathnameList, this.props.restaurants.list.toArray());
      if (!_.isUndefined(restaurantFromUrl)) {
        restaurantID = restaurantFromUrl.id;
      }
      if (restaurantID && location.pathname !== '/') {
        getServerTime().then((response) => {
          const time = response.data.time;
          setServerTime(time);
          selectedRestaurant(restaurantID, time);
        });
      } else if (location.pathname !== '/' && !this.excludePath(location.pathname)) {
        history.push({pathname: '/'})
      }

      this.getInitialValues();
    });
  }

  getInitialValues() {
    const {getPizzaSauces, getPizzaIngredients, getPizzaCategories, getProductTypes, getProductCategories} = this.props;
    getPizzaIngredients();
    getPizzaSauces();
    getPizzaCategories();
    getProductTypes();
    getProductCategories();
  }

  render() {
    return (
      <AppComponent
        openedBasket={this.props.openedBasket}
      />
    );
  }
}

AppLayout.propTypes = {
  currentRestaurantId: PropTypes.number,
  openedBasket: PropTypes.bool,
  user: PropTypes.object,
  getPizzaSauces: PropTypes.func,
  getPizzaIngredients: PropTypes.func,
  getPizzaCategories: PropTypes.func,
  getProductTypes: PropTypes.func,
  getProductCategories: PropTypes.func,
  signInAction: PropTypes.func,
  fetchRestaurants: PropTypes.func,
  selectedRestaurant: PropTypes.func,
  location: PropTypes.object,
  history: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    currentRestaurantId: state.restaurants.selectedId,
    restaurants: state.restaurants,
    openedBasket: state.basket.openedBasket,
    user: state.user
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getPizzaSauces: bindActionCreators(productActions.getPizzaSauces, dispatch),
    getPizzaIngredients: bindActionCreators(productActions.getPizzaIngredients, dispatch),
    getPizzaCategories: bindActionCreators(productActions.getPizzaCategories, dispatch),
    getProductTypes: bindActionCreators(productActions.getProductTypes, dispatch),
    getProductCategories: bindActionCreators(productActions.getProductCategories, dispatch),
    signInAction: bindActionCreators(userActions.signInAction, dispatch),
    fetchRestaurants: bindActionCreators(restaurantActions.fetchRestaurants, dispatch),
    selectedRestaurant: bindActionCreators(restaurantActions.selectedRestaurant, dispatch),
    exitCustomer: bindActionCreators(userActions.exitCustomer, dispatch),
    selectType: bindActionCreators(productActions.selectType, dispatch),
    setServerTime: bindActionCreators(pickUpActions.setServerTime, dispatch),
    getServerTime: bindActionCreators(appActions.getServerTime, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppLayout));



// WEBPACK FOOTER //
// ./src/containers/App.js